<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xHKt3z/tc-custom/9781250139429.jpg?1737765911530" alt="This image is the cover for the book Eat Your Feelings"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eat Your Feelings
      </h1>
      <p class="bookDescription body article font2">
        <p><b>**WINNER: Silver Award in the <i>Cookbooks: Natural, Nutrition, Organic, Vegetarian</i> category of the 2018 Living Now Book Award**<br/><br/>**One of the <i>Atlanta Journal-Consitution</i>'s s</b><b>elf-help books to help you live your best life in 2018**</b><b><br/><br/><i>Cosmopolitan: </i>"Take a bite of [Smith's] tasty advice."<br/><br/><i>Brit + Co: </i>"Offers intriguing insight into why we reach for certain (junk) foods when we’re sad, stressed, tired, hangry, and bored, and which nutrient-rich foods we should aim to eat instead." <br/><br/>Lindsey Smith, The Food Mood Girl, shows how you can transform your lifestyle by learning from your cravings and using mood-boosting ingredients every day</b><br/><br/>Blending together Lindsey Smith’s passion for health and wellness, food and humor, <i>Eat Your Feelings </i>is a humorous, lighthearted take on your typical diet book.<br/><br/>Busy young professionals wrestle with long hours, an exhausting dating culture, and the stress of the modern world. As days whiz by, it’s normal to gravitate toward food—a quick slice of pizza, a chocolate bar, or a bag of chips—that fulfills a craving of the moment or gives a quick energy boost. And this impulse makes sense. Food gives us a sense of pleasure and joy. It can provide us with satisfaction and comfort. Food can awaken each of our senses to something new each time we eat. It gives us energy, and quite literally sustains life as we know it. It <i>should</i> be emotional.<br/><br/>If you are feeling sad, stressed, exhausted, hangry, or bored, it’s comforting to eat dishes you love and crave. But Lindsey Smith shows how simple it is to make those same meals and snacks with mood-boosting ingredients that will physically nourish instead of processed foods. In <i>Eat Your Feelings</i>, Lindsey Smith, the Food Mood Girl, will look at ways to eat healthy food based on what people tend to crave the most during heightened emotional states, introducing recipes with crunchy, cheesy, creamy, sweet, and salty themes and drink alternatives for those  who tend to chug soda or coffee when all worked up.<br/><br/>It’s crucial to listen to your cravings: they are the gatekeepers that unlock the secrets to our unique bodies. But a major element of the Food Mood lifestyle is love, and revolutionizing the way you treat your body and your cravings will not only rid yourself of hanger pains but will also teach you how to listen and respond to your body with healthy ingredients and recipes.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lindsey Smith
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?87defa1e